/**
 * Файл с русскими переводами для интерфейса
 */
export const translations = {
  // Навигация
  "Dashboard": "Панель управления",
  "Settings": "Настройки",
  "New Time Series": "Новый временной ряд",
  "TimeSeries": "Временные ряды",
  "Toggle navigation": "Переключить навигацию",
  
  // Общие строки
  "Loading...": "Загрузка...",
  "Loading application...": "Загрузка приложения...",
  "Cancel": "Отмена",
  "Save": "Сохранить",
  "Edit": "Редактировать",
  "Delete": "Удалить",
  "Create": "Создать",
  "Add": "Добавить",
  "Search...": "Поиск...",
  "No data available": "Нет данных",
  "Error": "Ошибка",
  "Go to Dashboard": "Вернуться на панель управления",
  "Close": "Закрыть",
  "Try Again": "Попробовать снова",
  "Next": "Далее",
  "Previous": "Назад",
  
  // Панель управления
  "Time Series Dashboard": "Панель управления временными рядами",
  "Create New Time Series": "Создать новый временной ряд",
  "No time series match your search criteria.": "Нет временных рядов, соответствующих критериям поиска.",
  "No time series available. Create one to get started!": "Нет доступных временных рядов. Создайте один, чтобы начать!",
  "Clear Search": "Очистить поиск",
  "Create Time Series": "Создать временной ряд",
  "Creating...": "Создание...",
  "No description provided.": "Описание отсутствует.",
  "View Details": "Просмотр деталей",
  "Showing": "Показано",
  "to": "до",
  "of": "из",
  "time series": "временных рядов",

  // Формы
  "Name *": "Название *",
  "Description": "Описание",
  "Frequency *": "Частота *",
  "Tags": "Теги",
  "Hourly": "Ежечасно",
  "Daily": "Ежедневно",
  "Weekly": "Еженедельно",
  "Monthly": "Ежемесячно",
  "Quarterly": "Ежеквартально",
  "Yearly": "Ежегодно",
  "Comma-separated tags (e.g., sales, forecast, finance)": "Теги через запятую (например, продажи, прогноз, финансы)",
  "Перетащите CSV-файл сюда или": "Перетащите CSV-файл сюда или",
  "Выберите файл": "Выберите файл",
  "CSV files only": "Только CSV-файлы",
  
  // Детали временного ряда
  "Loading time series data...": "Загрузка данных временного ряда...",
  "Error Loading Time Series": "Ошибка загрузки временного ряда",
  "Overview": "Обзор",
  "Data": "Данные",
  "Forecasts": "Прогнозы",
  "AI Analysis": "AI-анализ",
  "No data available for this time series yet.": "Пока нет данных для этого временного ряда.",
  "Import data using the Data Import tab below.": "Импортируйте данные, используя вкладку Импорт данных ниже.",
  "Saving...": "Сохранение...",
  "Save Changes": "Сохранить изменения",
  
  // Импорт данных
  "Import Data": "Импорт данных",
  "Manual Entry": "Ручной ввод",
  "Bulk Entry": "Массовый ввод",
  "CSV Upload": "Загрузка CSV",
  "Timestamp": "Временная метка",
  "Value": "Значение",
  "Add Data Point": "Добавить точку данных",
  "Bulk Data Points": "Массовый ввод точек данных",
  "Enter each data point on a new line in the format: timestamp,value": "Введите каждую точку данных с новой строки в формате: временная_метка,значение",
  "Add Data Points": "Добавить точки данных",
  "CSV File": "CSV-файл",
  "Timestamp Column": "Колонка с временной меткой",
  "Value Column": "Колонка со значением",
  "Preview Data": "Предпросмотр данных",
  "Upload CSV": "Загрузить CSV",
  "Time series created, but failed to upload data": "Временной ряд создан, но данные не удалось загрузить",
  "Analyzing CSV file...": "Анализ CSV-файла...",
  "Analyzing CSV columns with AI...": "Анализ колонок CSV с помощью ИИ...",
  "Detected columns": "Обнаруженные колонки",
  "Failed to analyze CSV columns": "Не удалось проанализировать колонки CSV",
  
  // Таблица данных
  "records": "записей",
  "Export CSV": "Экспорт в CSV",
  "Search data...": "Поиск данных...",
  "Metadata": "Метаданные",
  "No matching records found": "Подходящие записи не найдены",
  "Outlier detected": "Обнаружен выброс",
  "View Metadata": "Просмотр метаданных",
  "None": "Отсутствуют",
  "entries": "записей",
  "First page": "Первая страница",
  "Previous page": "Предыдущая страница",
  "Next page": "Следующая страница",
  "Last page": "Последняя страница",
  
  // Прогнозы
  "New Forecast": "Новый прогноз",
  "Create New Forecast": "Создать новый прогноз",
  "Algorithm": "Алгоритм",
  "Forecast Horizon (periods)": "Горизонт прогноза (периоды)",
  "Confidence Level": "Уровень доверия",
  "Number of future periods to forecast": "Количество будущих периодов для прогноза",
  "Confidence interval for the forecast": "Доверительный интервал для прогноза",
  "ARIMA model parameters: p (autoregressive), d (differencing), q (moving average)": "Параметры модели ARIMA: p (авторегрессия), d (разностная), q (скользящее среднее)",
  "SARIMA model parameters: seasonal p, d, q and periods m": "Параметры модели SARIMA: сезонные p, d, q и период m",
  "Trend Type": "Тип тренда",
  "Seasonal Type": "Тип сезонности",
  "Additive": "Аддитивный",
  "Multiplicative": "Мультипликативный",
  "None Type": "Отсутствует",
  "Number of observations in a seasonal cycle": "Количество наблюдений в сезонном цикле",
  "Create Forecast...": "Создание прогноза...",
  "Generate Forecast": "Сгенерировать прогноз",
  "Loading forecasts...": "Загрузка прогнозов...",
  "No forecasts yet. Create one to predict future values.": "Пока нет прогнозов. Создайте один, чтобы предсказать будущие значения.",
  "Created": "Создан",
  "Horizon": "Горизонт",
  "Actions": "Действия",
  "days": "дней",
  "Delete forecast": "Удалить прогноз",
  "Forecast Details": "Детали прогноза",
  "Parameters": "Параметры",
  "Performance Metrics": "Метрики производительности",
  "No metrics available": "Нет доступных метрик",
  
  // AI Анализ
  "AI Insights": "AI-аналитика",
  "Error running analysis:": "Ошибка выполнения анализа:",
  "Generate Summary": "Сгенерировать резюме",
  "Detect Patterns": "Обнаружить шаблоны",
  "Find Anomalies": "Найти аномалии",
  "Get a comprehensive overview of your time series data": "Получить комплексный обзор данных временного ряда",
  "Identify recurring patterns and seasonality": "Определить повторяющиеся шаблоны и сезонность",
  "Discover unusual data points and outliers": "Обнаружить необычные точки данных и выбросы",
  "Available": "Доступно",
  "Not Available": "Недоступно",
  "Never run": "Никогда не запускался",
  "Last run:": "Последний запуск:",
  "Processing...": "Обработка...",
  "Run Analysis": "Запустить анализ",
  "Highlights from AI Analysis": "Основные моменты AI-анализа",
  "Summary": "Резюме",
  "Pattern Assessment": "Оценка шаблонов",
  "Anomaly Assessment": "Оценка аномалий",
  "Top Patterns": "Основные шаблоны",
  "Key Anomalies": "Ключевые аномалии",
  
  // Создание анализа
  "New Analysis": "Новый анализ",
  "Create New Analysis": "Создать новый анализ",
  "Analysis Type": "Тип анализа",
  "Time Series Summary": "Резюме временного ряда",
  "Pattern Detection": "Обнаружение шаблонов",
  "Anomaly Detection": "Обнаружение аномалий",
  "Provides an overview of the time series with key statistics and insights.": "Предоставляет обзор временного ряда с ключевыми статистиками и выводами.",
  "Detects recurring patterns, trends, and seasonality in the data.": "Обнаруживает повторяющиеся шаблоны, тренды и сезонность в данных.",
  "Identifies unusual data points and outliers in the time series.": "Определяет необычные точки данных и выбросы во временном ряде.",
  "Analyzing...": "Анализ...",
  "Start Analysis": "Начать анализ",
  "Loading analyses...": "Загрузка анализов...",
  "No analyses yet. Generate one to discover insights in your data.": "Пока нет анализов. Создайте один, чтобы обнаружить закономерности в ваших данных.",
  "Type": "Тип",
  "Details": "Детали",
  "Hide Details": "Скрыть детали",
  "Show Details": "Показать детали",
  "Statistics": "Статистика",
  "Minimum": "Минимум",
  "Maximum": "Максимум",
  "Average": "Среднее",
  "Trend": "Тренд",
  "Patterns": "Шаблоны",
  "Overall Assessment": "Общая оценка",
  "Detected Patterns": "Обнаруженные шаблоны",
  "Description Pattern": "Описание",
  "Confidence Pattern": "Достоверность",
  "Duration": "Продолжительность",
  "Detected Anomalies": "Обнаруженные аномалии",
  "Severity": "Серьезность",
  "Analysis Results": "Результаты анализа",
  
  // График
  "Time": "Время",
  "Actual Data": "Фактические данные",
  "Forecast": "Прогноз",
  "Confidence Interval": "Доверительный интервал",
  "No data available to display": "Нет данных для отображения",
  "Forecast Data": "Данные прогноза",
  "Date:": "Дата:",
  "Value:": "Значение:",
  "Lower:": "Нижняя граница:",
  "Upper:": "Верхняя граница:",
  
  // Настройки
  "Application Settings": "Настройки приложения",
  "Dark Mode (Coming Soon)": "Темный режим",
  "Change the application theme to dark mode.": "Изменить тему приложения на темную.",
  "Data Point Display Limit": "Лимит отображения точек данных",
  "points": "точек",
  "Maximum number of data points to display in charts and tables.": "Максимальное количество точек данных для отображения на графиках и в таблицах.",
  "Show Confidence Intervals": "Показывать доверительные интервалы",
  "Display confidence intervals on forecast charts.": "Отображать доверительные интервалы на графиках прогнозов.",
  "Default Forecast Algorithm": "Алгоритм прогноза по умолчанию",
  "Default algorithm to use for forecasting.": "Алгоритм, используемый для прогнозирования по умолчанию.",
  "Default Confidence Level": "Уровень доверия по умолчанию",
  "Default confidence level for forecast intervals.": "Уровень доверия по умолчанию для интервалов прогноза.",
  "Save Settings": "Сохранить настройки",
  "Reset to Defaults": "Сбросить до значений по умолчанию",
  "System Status": "Состояние системы",
  "API Connection": "Подключение к API",
  "Status of the backend API": "Статус API бэкенда",
  "Connected": "Подключено",
  "Disconnected": "Отключено",
  "Checking...": "Проверка...",
  "Unknown": "Неизвестно",
  "Version": "Версия",
  "Application version": "Версия приложения",
  "Check Connection": "Проверить соединение",
  "About": "О программе",
  "Time Series Analysis Platform": "Платформа анализа временных рядов",
  "A comprehensive system for time series analysis and forecasting with a modern web interface, REST API, and interactive visualization.": "Комплексная система для анализа временных рядов и прогнозирования с современным веб-интерфейсом, REST API и интерактивной визуализацией.",
  "Frontend": "Фронтенд",
  "Backend": "Бэкенд",
  "Database": "База данных",
  "AI": "ИИ",
  "Svelte with TypeScript": "Svelte с TypeScript",
  "Python FastAPI": "Python FastAPI",
  "PostgreSQL": "PostgreSQL",
  "OpenAI GPT-4o": "OpenAI GPT-4o",

  // Приложение
  "Application Error": "Ошибка приложения",
  "Please try refreshing the page or contact support if the issue persists.": "Пожалуйста, попробуйте обновить страницу или обратитесь в службу поддержки, если проблема не устраняется.",
  "Time Series Analysis Platform © 2025": "Платформа анализа временных рядов © 2025",
  "Version 1.0.0": "Версия 1.0.0"
};